module.exports = __webpack_public_path__ + "static/datatable-link-do-d001df3b63751a0e44e12ea89c5a5815.png";